/** Solutions shown on page 1 (alongside the application card). */
export const FIRST_PAGE_SOLUTIONS = 3;

/** Solutions shown on page 2+ (no application card). */
export const SUBSEQUENT_PAGE_SOLUTIONS = 4;

/** Page count for application accordion solutions (page 1 = 3, later = 4). */
export function getApplicationSolutionsPageCount(total: number): number {
  if (total <= FIRST_PAGE_SOLUTIONS) {
    return 1;
  }
  return (
    1 + Math.ceil((total - FIRST_PAGE_SOLUTIONS) / SUBSEQUENT_PAGE_SOLUTIONS)
  );
}

/** Inclusive-exclusive slice bounds for solutions on a given page. */
export function getApplicationSolutionsPageSlice(
  total: number,
  pageIndex: number,
): { start: number; end: number } {
  if (pageIndex <= 0) {
    return { start: 0, end: Math.min(FIRST_PAGE_SOLUTIONS, total) };
  }

  const start =
    FIRST_PAGE_SOLUTIONS + (pageIndex - 1) * SUBSEQUENT_PAGE_SOLUTIONS;
  return {
    start,
    end: Math.min(start + SUBSEQUENT_PAGE_SOLUTIONS, total),
  };
}
